import React from 'react'
import '../../Styles/about/TransitionAbout.styles.scss';

export const TransitionAbout = () => {
    return (
        <div className='transition-about'></div>
    )
}
